import { defineStore } from 'pinia'

const emptyPayload = () => ({
  currentRepairFile: null,
  rentalFileId: null,
  refreshCurrentRepairFile: null,
  onUpdateCurrentRepairFile: null,
  onShowGuaranteeExtensionBoomerangModal: null,
  onOpenRentalWarningModal: null
})

export const useRepairDrawerStore = defineStore('repairDrawer', {
  state: () => ({
    isOpen: false,
    openDeliveryClientDrawer: false,
    payload: emptyPayload()
  }),
  actions: {
    openDrawer(payload, options = {}) {
      this.payload = {
        ...this.payload,
        ...payload
      }
      this.openDeliveryClientDrawer = options.openDeliveryClientDrawer === true
      this.isOpen = true
    },
    closeDrawer() {
      this.isOpen = false
      this.openDeliveryClientDrawer = false
      this.payload = emptyPayload()
    },
    updateCurrentRepairFile(currentRepairFile) {
      this.payload.currentRepairFile = currentRepairFile
    },
    resetDeliveryClientState() {
      this.openDeliveryClientDrawer = false
    }
  }
})
